import { render, staticRenderFns } from "./AddressAddDialog.vue?vue&type=template&id=94a87052"
import script from "./AddressAddDialog.vue?vue&type=script&lang=js"
export * from "./AddressAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports